import { createStyleSheet, GlobalThemeInterface, headerHeight, vh } from '@groma-dev/blueprint';

export const getAppStyles = createStyleSheet(
  (theme: GlobalThemeInterface) => ({
    '@global': {
      body: {
        backgroundColor: theme.colors.$background100,
      },
    },
    mainContainer: {
      alignItems: 'center',
      backgroundColor: theme.colors.$background100,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxWidth: '100%',
      minHeight: vh(),
      minWidth: '100%',
      width: '100%',
    },
    appHeader: {
      '& .NavBar-navBarWrapper-local': {
        justifyContent: 'space-around',
      },
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      position: 'relative',
      scrollMarginTop: `${headerHeight}px`,
      width: '100%',
    },
    [`@media (max-width: ${theme.breakpoints.$md}px)`]: {
      auxContent: {
        ...theme.typography.$textSubtext100,
        columns: '2',
        whiteSpace: 'pre-line',
      },
    },
    [`@media (max-width: ${theme.breakpoints.$sm}px)`]: {},
  }),
  { name: 'App' }
);
